/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { ERC20Mock, ERC20MockInterface } from "../ERC20Mock";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "addressFundingStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "fundAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getFundingStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "giveAmountTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ERC20MockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC20MockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC20Mock__factory extends ContractFactory {
  constructor(...args: ERC20MockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    name_: string,
    symbol_: string,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(name_, symbol_, overrides || {});
  }
  override deploy(
    name_: string,
    symbol_: string,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(name_, symbol_, overrides || {}) as Promise<
      ERC20Mock & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ERC20Mock__factory {
    return super.connect(runner) as ERC20Mock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC20MockInterface {
    return new Interface(_abi) as ERC20MockInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): ERC20Mock {
    return new Contract(address, _abi, runner) as unknown as ERC20Mock;
  }
}
